import styled from 'styled-components'

const List = styled.div`
  max-width: 800px;
  margin: 0 auto;

  > p {
    border-top: 2px solid #bdbdbd;
    margin-top: 25px;
    font-size: 20px;
    font-size: 1.25rem;
    color: black;
    font-weight: 500;
    padding-top: 20px;

    @media screen and (min-width: 600px) {
      font-size: 26px;
      font-size: 1.625rem;
    }
  }

  .event-card {
    border-top: 2px solid #bdbdbd;

    &--same-day {
      border-top: 0;
    }

    p {
      font-size: 18px;
      font-size: 1.25rem;

      @media screen and (min-width: 600px) {
        font-size: 26px;
        font-size: 1.625rem;
      }
    }
  }

  ul {
    padding: 0 20px;
    margin: 0;

    @media screen and (min-width: 500px) {
      padding: 0 5.8vw;
    }

    @media screen and (min-width: 960px) {
      padding: 0;
    }
  }

  &.list-container {
    max-width: 100%;
    padding: 20px 20px 0px;

    @media screen and (min-width: 500px) {
      padding: 16px 5.8vw 0;
    }

    @media screen and (min-width: 1200px) {
      margin: 0px;
      padding: 0 0 0 60px;
    }

    p {
      margin-top: 0px;
      padding-top: 16px;
    }
  }
`

export default List
